import * as Types from '@/types';

import { gql } from '@apollo/client';
export const PriceEditDisplayInfoDetailFieldsFragmentDoc = gql`
  fragment PriceEditDisplayInfoDetailFields on PriceEditDisplayInfoDetail {
    currency
    title
    type
    value
  }
`;
